"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumEssentialDocName = void 0;
exports.EnumEssentialDocName = {
    AdvanceDirective: 'AdvanceDirective',
    CareInstructions: 'CareInstructions',
    DentalId: 'DentalID',
    FinancialAccounts: 'FinancialAccounts',
    MedicalId: 'MedicalID',
    PowerOfAttorney: 'PowerOfAttorney',
    PrescriptionId: 'PrescriptionID',
    VisionId: 'VisionID',
    Will: 'Will',
};
//# sourceMappingURL=enum-essential-doc-name.js.map